import { createContext, useContext, ReactNode } from 'react';
import { ZodSchema } from 'zod';
import './config';

const SchemaContext = createContext<ZodSchema<unknown> | null>(null);

interface SchemaProviderProps<T> {
  schema: ZodSchema<T>;
  children: ReactNode;
}

export const SchemaProvider = <T,>({ schema, children }: SchemaProviderProps<T>) => {
  return <SchemaContext.Provider value={schema}>{children}</SchemaContext.Provider>;
};

export const useSchema = () => {
  const context = useContext(SchemaContext);
  if (context === null) {
    throw new Error('useSchema must be used within a SchemaProvider');
  }
  return context as ZodSchema;
};
